import React,{ useRef } from "react";
import "./AboutUs.css";
import Logo from './content/pics/logo.jpeg'
import logo from "./content/pics/logo.jpeg";
import shreya from './content/pics/shreya.jpg'
import har from './content/pics/harshala.jpeg'
import insta from './content/pics/insta.png'
import linkedin from './content/pics/linkedin.png'


const AboutUs = () => {
  const teamMembersRef = useRef(null);

  const handleScrollDown = () => {
    // Scroll to the team members section when the scroll-down button is clicked
    
    if (teamMembersRef.current) {
      teamMembersRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div className="about-us">

<div className="logo-container-about fixed-logo">
        {/* <img src={logo} alt="Logo" className="logo-about" /> */}
        <div className="links-container-about">
          <a href="/">Home</a>
          <a href="/content">Content</a>
          <a href="/aboutus">About Us</a>
        </div>
      </div>

        <div className="content-padding" />

      <div className="hero-section">
        <img
          src={Logo}
          alt="Company Logo"
          className="company-logo"
        />
        <p className="company-description">
        <br></br>
          Welcome to "No Offense, But...," a blog that fearlessly explores the diverse experiences, challenges, and screwups of young adults in today's world. Through compelling stories and insightful articles, we aim to give a voice to the often unheard perspectives of the younger generation.<br/>
          <a href="https://www.instagram.com/_no.offense.but_/" target="_blank"><img src={insta} className="img-small"></img><div className="instaid">_no.offense.but_</div></a></p>
        <div className="scroll-down-symbol" onClick={handleScrollDown}>
          ▼ {/* Down-pointing arrow symbol */}
        </div>
   

    
      </div>
      <div ref={teamMembersRef} className="meethead">MEET THE TEAM</div>
      <div className="team-members">
        <div className="team-member team-member1">
          <img
            src={shreya}
            alt="Team Member 1"
            className="member-image"
          />
          <p className="member-description1">
          I'm Shreya Shastry, from BMS College of Engineering. My entire childhood was spent devouring whatever book I could get my hands on. I love all genres, be it fiction, mystery, thrillers, or YA. As of late, I'm into mythology and non-fiction. 
I found a penchant for writing a few years later, but never really showcased it to anyone beyond close friends and family though I've always wanted to write something of my own and put it out into the world. I'm equal parts of excited and terrified to finally have people get to know me through my words. No offense, but I think it's time to take my place in the world.
          </p>
          
        </div>
        <div className="team-member team-member2">
          <img
            src={har}
            alt="Team Member 2"
            className="member-image"
          />
          <p className="member-description2">
          I'm Harshala Rani,  a student of BMS College of Engineering. I have been born and bought up in Mysore and moved to Bangalore for college. After every Parent-Teacher meeting in school, my mom would take me to a bookstore to buy me as many books I wanted, because she always knew that was my perfect gift. Fiction has always been my perfect escape from reality. As for writing, my personal diary has been my faithful confidant since childhood. But, creative writing is something I began very recently. No offense but, its my time to weave captivating tales.
          </p>
        </div>
      </div>
      
      <div class="feature">
      <div className="feature-child"><p><div className="instaid">Shreya Shastry</div><a href="https://www.instagram.com/shreya_shastry/" target="_blank"><img src={insta} className="insta"></img></a>
    <a href="https://www.linkedin.com/in/shreya-shastry-331984233/" target="_blank"><img src={linkedin} className="linkedin"></img></a>
    </p></div>

  <div className="feature-child"><p><div className="instaid">Harshala Rani</div><a href="https://www.instagram.com/harshala__ranii/" target="_blank"><img src={insta} className="insta"></img></a>
  <a href="https://www.linkedin.com/in/harshala-rani-a26880244/" target="_blank"><img src={linkedin} className="linkedin"></img></a>
  </p></div>
</div>
    </div>


  );
};

export default AboutUs;
